/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { HubbleShipmentFiltersQuery } from "./HubbleShipmentFiltersQuery";
import {
  HubbleShipmentFiltersQueryFromJSON,
  HubbleShipmentFiltersQueryFromJSONTyped,
  HubbleShipmentFiltersQueryToJSON,
  HubbleShipmentFiltersQueryToJSONTyped,
} from "./HubbleShipmentFiltersQuery";
import type { CarrierShipmentReportConfig } from "./CarrierShipmentReportConfig";
import {
  CarrierShipmentReportConfigFromJSON,
  CarrierShipmentReportConfigFromJSONTyped,
  CarrierShipmentReportConfigToJSON,
  CarrierShipmentReportConfigToJSONTyped,
} from "./CarrierShipmentReportConfig";

/**
 *
 * @export
 * @interface CarrierShipmentReportRequest
 */
export interface CarrierShipmentReportRequest {
  /**
   *
   * @type {HubbleShipmentFiltersQuery}
   * @memberof CarrierShipmentReportRequest
   */
  query?: HubbleShipmentFiltersQuery | null;
  /**
   *
   * @type {Array<string>}
   * @memberof CarrierShipmentReportRequest
   */
  shipmentIds?: Array<string> | null;
  /**
   *
   * @type {CarrierShipmentReportConfig}
   * @memberof CarrierShipmentReportRequest
   */
  config: CarrierShipmentReportConfig;
  /**
   *
   * @type {string}
   * @memberof CarrierShipmentReportRequest
   */
  companyName?: string | null;
}

/**
 * Check if a given object implements the CarrierShipmentReportRequest interface.
 */
export function instanceOfCarrierShipmentReportRequest(
  value: object,
): value is CarrierShipmentReportRequest {
  if (!("config" in value) || value["config"] === undefined) return false;
  return true;
}

export function CarrierShipmentReportRequestFromJSON(
  json: any,
): CarrierShipmentReportRequest {
  return CarrierShipmentReportRequestFromJSONTyped(json, false);
}

export function CarrierShipmentReportRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierShipmentReportRequest {
  if (json == null) {
    return json;
  }
  return {
    query:
      json["query"] == null
        ? undefined
        : HubbleShipmentFiltersQueryFromJSON(json["query"]),
    shipmentIds: json["shipmentIds"] == null ? undefined : json["shipmentIds"],
    config: CarrierShipmentReportConfigFromJSON(json["config"]),
    companyName: json["companyName"] == null ? undefined : json["companyName"],
  };
}

export function CarrierShipmentReportRequestToJSON(
  json: any,
): CarrierShipmentReportRequest {
  return CarrierShipmentReportRequestToJSONTyped(json, false);
}

export function CarrierShipmentReportRequestToJSONTyped(
  value?: CarrierShipmentReportRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    query: HubbleShipmentFiltersQueryToJSON(value["query"]),
    shipmentIds: value["shipmentIds"],
    config: CarrierShipmentReportConfigToJSON(value["config"]),
    companyName: value["companyName"],
  };
}
